import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import ColumnModel, {
  Column,
} from "@mapmycustomers/shared/types/viewModel/internalModel/ColumnModel";

// Keeps one column per field: the first visible one, otherwise the first one
const dedupeColumnsByField = (columns: ColumnModel): ColumnModel => {
  const keptColumnByField = new Map<IField, Column>();
  columns.forEach((column) => {
    const keptColumn = keptColumnByField.get(column.field);
    if (!keptColumn || (!keptColumn.visible && column.visible)) {
      keptColumnByField.set(column.field, column);
    }
  });
  return columns.filter((column) => keptColumnByField.get(column.field) === column);
};

export default dedupeColumnsByField;
